module.exports = __webpack_public_path__ + "img/companyProfile.ad269962.png";